import { module } from 'angular';

import { default as hasPermissionName, HasPermission } from './has-permission/has-permission.component.ajs';
import { default as hasPermissionDirectiveName, HasPermissionDirective } from './has-permission/has-permission.directive';
import { default as hasRoleName, HasRole } from './has-role/has-role.component';
import { default as hasRoleDirectiveName, HasRoleDirective } from './has-role/has-role.directive';
import { default as lacksPermissionName, LacksPermission } from './lacks-permission/lacks-permission.component';
import { default as lacksPermissionDirectiveName, LacksPermissionDirective } from './lacks-permission/lacks-permission.directive';

export default module('contact.commons.toolbox.permission', [])
  // ** HAS-PERMISSION
  .component(hasPermissionName, new HasPermission())
  /** @deprecated */ .directive(hasPermissionDirectiveName, HasPermissionDirective)
  // ** HAS-ROLE
  .component(hasRoleName, new HasRole())
  /** @deprecated */ .directive(hasRoleDirectiveName, HasRoleDirective)
  // ** LACKS-PERMISSION
  .component(lacksPermissionName, new LacksPermission())
  /** @deprecated */ .directive(lacksPermissionDirectiveName, LacksPermissionDirective).name;
